import React from 'react';
import classNames from 'classnames';;
import { connect } from 'react-redux';

const mapStateToProps = ({
  tiles: {
    selectedCategory,
    selectedLocation: { locationName }
  },
  currentUser
}) => {
  return {
    categoryName: selectedCategory,
    locationName: locationName,
    userRole: currentUser.data['role']
  };
};

const Tile = ({
  tileId,
  link,
  category,
  title,
  description,
  imageUrl = '',
  video = false,
  favourited = false,
  onFavourite = tileId => {},
  tileSize = 3,
  onClickSurvey = () => {},
  position,
  locationName,
  categoryName,
  context = '',
  userRole
}) => {
  const pushTileEventToDataLayer = eventKey => {
    window.dataLayer.push({
      event: eventKey,
      label: title,
      group: context,
      labelContext: category,
      info: {
        url: link,
        id: tileId,
        location: undefined,
        position: position
      },
      data: {
        value: undefined,
        filters: [
          {
            type: 'Category',
            label: categoryName ? categoryName : 'Everything'
          },
          {
            type: 'Location',
            label: locationName ? locationName : 'All Campuses'
          }
        ]
      }
    });
  };

  const handleFavouriteTile = () => {
    pushTileEventToDataLayer(
      `custom.tile.favourite.${favourited ? 'off' : 'on'}`
    );

    onFavourite(tileId);
  };

  const handleClickTile = () => {
    pushTileEventToDataLayer('custom.tile.click');

    onClickSurvey();
  };

  let aStyle =
    tileSize !== 1 && !!imageUrl
      ? {
          backgroundImage: 'url(' + imageUrl + ')'
        }
      : null;

  return (
    <div className={classNames(`tile-size-${tileSize}`)}>
      <a
        className={classNames(
          'tile',
          { 'tile-image': tileSize !== 1 && !!imageUrl },
          {
            ['tile-' +
            (category &&
              category.replace(/\s+/g, '-').toLowerCase())]: !!category
          },
          { 'tile-video': video }
        )}
        style={aStyle}
        href={link}
        tile-id={tileId}
        onClick={handleClickTile}
      >
        <div className="tile-content">
          {category ? <span className="category">{category}</span> : null}
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div className="top-right" />
      </a>
      {userRole == 'STUDENT' ? (
        <button
          className={classNames('favourite-button', {
            'favourite-button--favourited': favourited
          })}
          onClick={handleFavouriteTile}
        >
          <span className="sr-only">Favourite "{title}" Tile</span>
        </button>
      ) : (
        ''
      )}
    </div>
  );
};

export default connect(mapStateToProps)(Tile);
